import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_INVITATIONS_ENDPOINT } from '@/services/org-admin';
import type { CreateOrgInvitationInput, OrgInvitationResponse } from '@/services/org-admin';

export function useCreateOrgInvitation() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: async (input: CreateOrgInvitationInput) => {
      const { data } = await axiosInstance.post<OrgInvitationResponse>(ORG_INVITATIONS_ENDPOINT(orgId!), input);
      return data.invitation;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['org-invitations', orgId] });
    },
    // Caller already shows its own success/error toast — suppress the global one.
    meta: { silent: true },
  });
}
